import { getAsyncInjectors } from 'helpers/asyncInjectors';
import App from 'modules/App';
import Account from 'modules/Account';
import Mobile from 'modules/Mobile';
import OidcService from 'services/OidcService';
export const mobileGuard = async (context)=>{
    const { store, cookies, fullPath, getUrl } = context;
    const { injectReducer, injectSagas } = getAsyncInjectors(store);
    injectReducer(Mobile.constants.MODULE_ID, Mobile.reducer);
    injectSagas(Mobile.constants.MODULE_ID, Mobile.sagas);
    const state = store.getState();
    const restoreSsoAt = cookies.get('restoreSsoAt');
    const user = await OidcService.getUser();
    if (!user) {
        await store.dispatch(Mobile.actions.restoreSso(restoreSsoAt, fullPath)).catch(()=>{});
    }
    const activeProfileMainUrlRoute = Account.selectors.activeProfileMainUrlRoute(state);
    const isPatientAccount = Account.selectors.isPatientAccount(state);
    const isMobileDisplayMode = App.selectors.isMobileDisplayMode(state);
    if (!isPatientAccount || !isMobileDisplayMode) {
        const { name, params } = activeProfileMainUrlRoute;
        return getUrl(name, params);
    }
    return null;
};
